module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('title', [_vm._v("I Hope You Dance: A Year of Weddings Novella")]), _c('link', {
    attrs: {
      "href": "styles/default.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "txc1",
    attrs: {
      "id": "pz3-1"
    }
  }, [_vm._v("To the One who causes His children to take up their tambourines and go forth to the dances of the merrymakers.")]), _vm._v(" "), _c('p', {
    staticClass: "txc"
  }, [_vm._v("—J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EREMIAH")]), _vm._v(" 31:4")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-48141b2a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dedication.vue
// module id = 66
// module chunks = 0